import React from 'react';

const Faq = () => {
  return (
    <div>
      <h1>Testimonials</h1>
      <p>"Using the AI Web Accessibility Checker, we were able to identify and fix numerous accessibility issues on our website, making it more inclusive for all our users." - Jane Doe, Web Developer</p>

        <h2>FAQs</h2>

        <h3>What is web accessibility?</h3>
<p>Web accessibility means that websites, tools, and technologies are designed and developed so that people with disabilities can use them.</p>

<h3>Why is web accessibility important?</h3>
<p>It ensures equal access to information and functionalities for all users, regardless of their abilities.</p>

<h3>How does the AI Web Accessibility Checker work?</h3>
<p>Our tool uses advanced algorithms to scan your website against WCAG 2.0 guidelines and provides detailed reports on areas needing improvement.</p>
    </div>
  );
};

export default Faq;